import axios from "axios";

export default {
  submit (params: login) {
    return new Promise((resolve, reject) => {
      axios.post(`${process.env.VUE_APP_API}/admin/staff/authenticate`, params)
        .then(response => {
          resolve((response.data))
        })
        .catch(error => {
          reject(error.response)
        })
    })
  }
}

interface login{
  email: string,
  password: string
}